export default __webpack_public_path__ + "lines@2x.a1520f26.png";